import { render, staticRenderFns } from "./StyleCommentsHeader.vue?vue&type=template&id=5265a12a&scoped=true&"
import script from "./StyleCommentsHeader.vue?vue&type=script&lang=js&"
export * from "./StyleCommentsHeader.vue?vue&type=script&lang=js&"
import style0 from "./StyleCommentsHeader.vue?vue&type=style&index=0&id=5265a12a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5265a12a",
  null
  
)

export default component.exports